import {post} from './base.service'
export default{
    logout(){
        return post('/app/user/logout');
    }
}


// WEBPACK FOOTER //
// ./src/service/settings.service.js